import lodash from 'lodash'
import Base from '../base.store'

const baseUrl = '/api/v1/ws/kadee-resources'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        queryKadee(context, { shipCode,  pid, config = {} }) {
            const wheres = [];
            wheres.push({ name: 'isActive', equals: {value: true}});
            if (pid) {
                wheres.push({ openBucket: true, name: 'offenders.pid', equals: { value: pid }});
                wheres.push({ closeBucket: true, logic: "OR", name: 'offenders.juristicId', equals: { value: pid }});
            } else if (shipCode) {
                wheres.push({ name: 'ships.code', equals: {value: shipCode}});
            }
            const queryParam = {
                "isSelectAll": true,
                "page": 0,
                "size": 1,
                "sort": [],
                "where": wheres,
                "children": [
                    {
                        "isSelectAll": true,
                        "name": "arrestTeams",
                        "page": 0,
                        "size": 1000,
                        "sort": [
                            {
                                "name": "createDate",
                                "type": "ASC"
                            }
                        ]
                    },
                    {
                        "isSelectAll": true,
                        "name": "chargedDetails",
                        "page": 0,
                        "size": 1000,
                        "sort": [
                            {
                                "name": "createDate",
                                "type": "ASC"
                            }
                        ]
                    },
                    {
                        "isSelectAll": true,
                        "name": "ships",
                        "page": 0,
                        "size": 1000,
                        "sort": [
                            {
                                "name": "createDate",
                                "type": "ASC"
                            }
                        ]
                    },
                    {
                        "isSelectAll": true,
                        "name": "administrativeActions",
                        "page": 0,
                        "size": 1000,
                        "sort": [
                            {
                                "name": "createDate",
                                "type": "ASC"
                            }
                        ],
                        "where": [
                            {
                                "name": "commanderKey.key",
                                "in": {
                                    "value": [
                                        "A"
                                    ]
                                }
                            }
                        ],
                        "children": [
                            {
                                "name": "administrativeOrderDetails",
                                "isSelectAll": true,
                                "page": 0,
                                "size": 1000,
                                "sort": [
                                    {
                                        "name": "createDate",
                                        "type": "ASC"
                                    }
                                ]
                            },
                            {
                                "name": "shipLockNotifications",
                                "isSelectAll": true,
                                "page": 0,
                                "size": 1000,
                                "sort": [
                                    {
                                        "name": "createDate",
                                        "type": "ASC"
                                    }
                                ]
                            },
                            {
                                "name": "attachments",
                                "isSelectAll": true,
                                "page": 0,
                                "size": 1000,
                                "sort": [
                                    {
                                        "name": "createDate",
                                        "type": "ASC"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "isSelectAll": true,
                        "name": "complaints",
                        "page": 0,
                        "size": 1000,
                        "sort": [
                            {
                                "name": "createDate",
                                "type": "ASC"
                            }
                        ],
                        "children": [
                            {
                                "isSelectAll": true,
                                "name": "complaintOwners",
                                "page": 0,
                                "size": 1000,
                                "sort": [
                                    {
                                        "name": "createDate",
                                        "type": "ASC"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "isSelectAll": true,
                        "name": "offenders",
                        "page": 0,
                        "size": 1000,
                        "sort": [
                            {
                                "name": "createDate",
                                "type": "ASC"
                            }
                        ],
                        "children": [
                            {
                                "isSelectAll": true,
                                "name": "chargedDetails",
                                "page": 0,
                                "size": 1000,
                                "sort": [
                                    {
                                        "name": "createDate",
                                        "type": "ASC"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
            return base.request.post(`${baseUrl}/query-kadee`, { ...queryParam, ...config });
        }
    },
    mutations: {
        ...base.mutations
    },
}
